import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-edit-icon',
  templateUrl: './design-edit.component.html'
})
export class DesignEditComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
